// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.operator-utilization-dashboard {
  --operator-ink: #0f172a;
  --operator-muted: #64748b;
  --operator-border: rgba(148, 163, 184, 0.2);
  --operator-surface: rgba(255, 255, 255, 0.94);
  --operator-primary: #053c83;
  --operator-secondary: #2f539d;
  position: relative;
  margin-top: 28px;
  padding: 2px 0 34px;
  color: var(--operator-ink);
}

.operator-utilization-hero {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  min-height: 156px;
  margin-bottom: 18px;
  padding: 28px 30px;
  border: 1px solid rgba(99, 102, 241, 0.14);
  border-radius: 24px;
  background: radial-gradient(circle at 92% 20%, rgba(56, 189, 248, 0.22), transparent 28%), radial-gradient(circle at 68% 120%, rgba(139, 92, 246, 0.18), transparent 36%), linear-gradient(135deg, #071936 0%, #0b2d63 52%, #173f8f 100%);
  box-shadow: 0 20px 55px rgba(15, 23, 42, 0.17);
  color: #fff;
}
.operator-utilization-hero h2 {
  color: #fff;
}
.operator-utilization-hero::after {
  content: "";
  position: absolute;
  width: 220px;
  height: 220px;
  right: -90px;
  top: -90px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 0 0 26px rgba(255, 255, 255, 0.025), 0 0 0 52px rgba(255, 255, 255, 0.02);
}
.operator-utilization-hero h2 {
  position: relative;
  z-index: 1;
  margin: 6px 0 8px;
  font-size: clamp(25px, 2.2vw, 36px);
  line-height: 1.1;
  letter-spacing: -0.7px;
}
.operator-utilization-hero p {
  position: relative;
  z-index: 1;
  max-width: 720px;
  margin: 0;
  color: rgba(226, 232, 240, 0.84);
  font-size: 14px;
  line-height: 1.65;
}

.operator-utilization-hero__eyebrow,
.operator-utilization-card__eyebrow {
  display: block;
  color: #67e8f9;
  font-size: 10px;
  font-weight: 640;
  letter-spacing: 1.5px;
}

.operator-utilization-hero__meta {
  position: relative;
  z-index: 2;
  min-width: 195px;
  padding: 16px 18px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(12px);
}
.operator-utilization-hero__meta span,
.operator-utilization-hero__meta strong,
.operator-utilization-hero__meta small {
  display: block;
}
.operator-utilization-hero__meta span {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #bbf7d0;
  font-size: 11px;
  font-weight: 700;
}
.operator-utilization-hero__meta strong {
  margin-top: 9px;
  font-size: 13px;
  letter-spacing: 0.2px;
  color: #fff;
}
.operator-utilization-hero__meta small {
  margin-top: 4px;
  color: rgba(226, 232, 240, 0.68);
}

.operator-live-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #4ade80;
  box-shadow: 0 0 0 5px rgba(74, 222, 128, 0.12);
}

.operator-utilization-kpi-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 18px;
}

.operator-utilization-chart-grid {
  display: grid;
  gap: 18px;
  margin-bottom: 18px;
}

.operator-utilization-chart-grid--overview,
.operator-utilization-chart-grid--balanced {
  grid-template-columns: minmax(310px, 0.76fr) minmax(0, 1.74fr);
}

.operator-utilization-chart-grid--reasons {
  grid-template-columns: 1fr;
}

.operator-utilization-card {
  min-width: 0;
  padding: 22px 22px 16px;
  border: 1px solid var(--operator-border);
  border-radius: 22px;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(248, 250, 252, 0.93));
  box-shadow: 0 15px 42px rgba(15, 23, 42, 0.07);
  transition: transform 220ms ease, box-shadow 220ms ease, border-color 220ms ease;
}
.operator-utilization-card:hover {
  transform: translateY(-2px);
  border-color: rgba(47, 83, 157, 0.24);
  box-shadow: 0 20px 48px rgba(15, 23, 42, 0.1);
}

.operator-utilization-card--wide {
  min-width: 0;
}

.operator-utilization-card--full {
  width: 100%;
}

.operator-utilization-card__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 8px;
}
.operator-utilization-card__header h3 {
  margin: 4px 0 3px;
  color: #0f172a;
  font-size: 18px;
  font-weight: 640;
  letter-spacing: -0.3px;
}
.operator-utilization-card__header p {
  margin: 0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.5;
}
.operator-utilization-card__header .operator-utilization-card__eyebrow {
  color: #2f539d;
}

.operator-utilization-card__badge {
  flex-shrink: 0;
  padding: 7px 10px;
  border: 1px solid rgba(14, 165, 233, 0.16);
  border-radius: 999px;
  background: rgba(14, 165, 233, 0.08);
  color: #0369a1;
  font-size: 12px;
  font-weight: 800;
}

.operator-utilization-card__badge--violet {
  border-color: rgba(124, 58, 237, 0.16);
  background: rgba(124, 58, 237, 0.08);
  color: #6d28d9;
}

.operator-utilization-card__badge--danger {
  border-color: rgba(239, 68, 68, 0.15);
  background: rgba(239, 68, 68, 0.08);
  color: #dc2626;
}

.operator-view-switch {
  display: inline-flex;
  flex-shrink: 0;
  gap: 3px;
  padding: 3px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
}
.operator-view-switch button {
  border: 0;
  border-radius: 7px;
  padding: 6px 10px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  font-size: 11px;
  font-weight: 700;
  transition: all 180ms ease;
}
.operator-view-switch button.active {
  background: #fff;
  color: #1d4ed8;
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.08);
}

.operator-utilization-loading,
.operator-utilization-empty {
  min-height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 30px;
  border: 1px dashed #cbd5e1;
  border-radius: 22px;
  background: #fff;
  text-align: center;
}

.operator-utilization-loading__spinner {
  width: 30px;
  height: 30px;
  border: 3px solid #dbeafe;
  border-top-color: #2563eb;
  border-radius: 50%;
  animation: operator-spin 0.85s linear infinite;
}

.operator-utilization-loading {
  text-align: left;
}
.operator-utilization-loading strong {
  display: block;
  color: #0f172a;
}
.operator-utilization-loading p {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 12px;
}

.operator-utilization-empty {
  flex-direction: column;
}
.operator-utilization-empty > span {
  color: #94a3b8;
  font-size: 38px;
}
.operator-utilization-empty h3 {
  margin: 0;
  color: #0f172a;
}
.operator-utilization-empty p {
  margin: 0;
  color: #64748b;
}

@keyframes operator-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 1500px) {
  .operator-utilization-kpi-grid {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}
@media (max-width: 1050px) {
  .operator-utilization-chart-grid--overview,
  .operator-utilization-chart-grid--balanced {
    grid-template-columns: 1fr;
  }
  .operator-utilization-hero {
    align-items: flex-start;
    flex-direction: column;
  }
  .operator-utilization-hero__meta {
    min-width: 240px;
  }
}
@media (max-width: 760px) {
  .operator-utilization-dashboard {
    margin-top: 18px;
  }
  .operator-utilization-hero {
    min-height: auto;
    padding: 22px 18px;
    border-radius: 18px;
  }
  .operator-utilization-hero__meta {
    width: 100%;
    min-width: 0;
  }
  .operator-utilization-kpi-grid {
    grid-template-columns: 1fr;
  }
  .operator-utilization-card {
    padding: 18px 14px 12px;
    border-radius: 17px;
  }
  .operator-utilization-card__header {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/manufacturing_app/Dashboard/operator-utilization/OperatorUtilizationDashboard.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,yBAAA;EACA,2CAAA;EACA,6CAAA;EACA,2BAAA;EACA,6BAAA;EAEA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;AAAF;;AAGA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,0CAAA;EACA,mBAAA;EACA,yOACE;EAGF,8CAAA;EACA,WAAA;AAHF;AAIE;EACE,WAAA;AAFJ;AAIE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,2CAAA;EACA,uFACE;AAHN;AAOE;EACE,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,mCAAA;EACA,gBAAA;EACA,sBAAA;AALJ;AAQE;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,SAAA;EACA,gCAAA;EACA,eAAA;EACA,iBAAA;AANJ;;AAUA;;EAEE,cAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AAPF;;AAUA;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,2CAAA;EACA,mBAAA;EACA,qCAAA;EACA,2BAAA;AAPF;AASE;;;EAGE,cAAA;AAPJ;AAUE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AARJ;AAWE;EACE,eAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;AATJ;AAYE;EACE,eAAA;EACA,gCAAA;AAVJ;;AAcA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,8CAAA;AAXF;;AAcA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,mBAAA;AAXF;;AAcA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAXF;;AAcA;;EAEE,8DAAA;AAXF;;AAcA;EACE,0BAAA;AAXF;;AAcA;EACE,YAAA;EACA,uBAAA;EACA,wCAAA;EACA,mBAAA;EACA,yFACE;EACF,8CAAA;EACA,gFACE;AAbJ;AAiBE;EACE,2BAAA;EACA,qCAAA;EACA,6CAAA;AAfJ;;AAmBA;EACE,YAAA;AAhBF;;AAmBA;EACE,WAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;AAhBF;AAkBE;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AAhBJ;AAmBE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAjBJ;AAoBE;EACE,cAAA;AAlBJ;;AAsBA;EACE,cAAA;EACA,iBAAA;EACA,0CAAA;EACA,oBAAA;EACA,oCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAnBF;;AAsBA;EACE,sCAAA;EACA,oCAAA;EACA,cAAA;AAnBF;;AAsBA;EACE,qCAAA;EACA,mCAAA;EACA,cAAA;AAnBF;;AAsBA;EACE,oBAAA;EACA,cAAA;EACA,QAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAnBF;AAqBE;EACE,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AAnBJ;AAqBI;EACE,gBAAA;EACA,cAAA;EACA,6CAAA;AAnBN;;AAwBA;;EAEE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,0BAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AArBF;;AAwBA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,8CAAA;AArBF;;AAwBA;EACE,gBAAA;AArBF;AAuBE;EACE,cAAA;EACA,cAAA;AArBJ;AAwBE;EACE,eAAA;EACA,cAAA;EACA,eAAA;AAtBJ;;AA0BA;EACE,sBAAA;AAvBF;AAyBE;EACE,cAAA;EACA,eAAA;AAvBJ;AA0BE;EACE,SAAA;EACA,cAAA;AAxBJ;AA2BE;EACE,SAAA;EACA,cAAA;AAzBJ;;AA6BA;EACE;IACE,yBAAA;EA1BF;AACF;AA6BA;EACE;IACE,gDAAA;EA3BF;AACF;AA8BA;EACE;;IAEE,0BAAA;EA5BF;EA+BA;IACE,uBAAA;IACA,sBAAA;EA7BF;EAgCA;IACE,gBAAA;EA9BF;AACF;AAiCA;EACE;IACE,gBAAA;EA/BF;EAkCA;IACE,gBAAA;IACA,kBAAA;IACA,mBAAA;EAhCF;EAmCA;IACE,WAAA;IACA,YAAA;EAjCF;EAoCA;IACE,0BAAA;EAlCF;EAqCA;IACE,uBAAA;IACA,mBAAA;EAnCF;EAsCA;IACE,sBAAA;EApCF;AACF","sourcesContent":[".operator-utilization-dashboard {\n  --operator-ink: #0f172a;\n  --operator-muted: #64748b;\n  --operator-border: rgba(148, 163, 184, 0.2);\n  --operator-surface: rgba(255, 255, 255, 0.94);\n  --operator-primary: #053c83;\n  --operator-secondary: #2f539d;\n\n  position: relative;\n  margin-top: 28px;\n  padding: 2px 0 34px;\n  color: var(--operator-ink);\n}\n\n.operator-utilization-hero {\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  min-height: 156px;\n  margin-bottom: 18px;\n  padding: 28px 30px;\n  border: 1px solid rgba(99, 102, 241, 0.14);\n  border-radius: 24px;\n  background:\n    radial-gradient(circle at 92% 20%, rgba(56, 189, 248, 0.22), transparent 28%),\n    radial-gradient(circle at 68% 120%, rgba(139, 92, 246, 0.18), transparent 36%),\n    linear-gradient(135deg, #071936 0%, #0b2d63 52%, #173f8f 100%);\n  box-shadow: 0 20px 55px rgba(15, 23, 42, 0.17);\n  color: #fff;\n  h2{\n    color: #fff;\n  }\n  &::after {\n    content: \"\";\n    position: absolute;\n    width: 220px;\n    height: 220px;\n    right: -90px;\n    top: -90px;\n    border-radius: 50%;\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    box-shadow:\n      0 0 0 26px rgba(255, 255, 255, 0.025),\n      0 0 0 52px rgba(255, 255, 255, 0.02);\n  }\n\n  h2 {\n    position: relative;\n    z-index: 1;\n    margin: 6px 0 8px;\n    font-size: clamp(25px, 2.2vw, 36px);\n    line-height: 1.1;\n    letter-spacing: -0.7px;\n  }\n\n  p {\n    position: relative;\n    z-index: 1;\n    max-width: 720px;\n    margin: 0;\n    color: rgba(226, 232, 240, 0.84);\n    font-size: 14px;\n    line-height: 1.65;\n  }\n}\n\n.operator-utilization-hero__eyebrow,\n.operator-utilization-card__eyebrow {\n  display: block;\n  color: #67e8f9;\n  font-size: 10px;\n  font-weight: 640;\n  letter-spacing: 1.5px;\n}\n\n.operator-utilization-hero__meta {\n  position: relative;\n  z-index: 2;\n  min-width: 195px;\n  padding: 16px 18px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(12px);\n\n  span,\n  strong,\n  small {\n    display: block;\n  }\n\n  span {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    color: #bbf7d0;\n    font-size: 11px;\n    font-weight: 700;\n  }\n\n  strong {\n    margin-top: 9px;\n    font-size: 13px;\n    letter-spacing: 0.2px;\n    color: #fff;\n  }\n\n  small {\n    margin-top: 4px;\n    color: rgba(226, 232, 240, 0.68);\n  }\n}\n\n.operator-live-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: #4ade80;\n  box-shadow: 0 0 0 5px rgba(74, 222, 128, 0.12);\n}\n\n.operator-utilization-kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 14px;\n  margin-bottom: 18px;\n}\n\n.operator-utilization-chart-grid {\n  display: grid;\n  gap: 18px;\n  margin-bottom: 18px;\n}\n\n.operator-utilization-chart-grid--overview,\n.operator-utilization-chart-grid--balanced {\n  grid-template-columns: minmax(310px, 0.76fr) minmax(0, 1.74fr);\n}\n\n.operator-utilization-chart-grid--reasons {\n  grid-template-columns: 1fr;\n}\n\n.operator-utilization-card {\n  min-width: 0;\n  padding: 22px 22px 16px;\n  border: 1px solid var(--operator-border);\n  border-radius: 22px;\n  background:\n    linear-gradient(145deg, rgba(255, 255, 255, 0.98), rgba(248, 250, 252, 0.93));\n  box-shadow: 0 15px 42px rgba(15, 23, 42, 0.07);\n  transition:\n    transform 220ms ease,\n    box-shadow 220ms ease,\n    border-color 220ms ease;\n\n  &:hover {\n    transform: translateY(-2px);\n    border-color: rgba(47, 83, 157, 0.24);\n    box-shadow: 0 20px 48px rgba(15, 23, 42, 0.1);\n  }\n}\n\n.operator-utilization-card--wide {\n  min-width: 0;\n}\n\n.operator-utilization-card--full {\n  width: 100%;\n}\n\n.operator-utilization-card__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 14px;\n  margin-bottom: 8px;\n\n  h3 {\n    margin: 4px 0 3px;\n    color: #0f172a;\n    font-size: 18px;\n    font-weight: 640;\n    letter-spacing: -0.3px;\n  }\n\n  p {\n    margin: 0;\n    color: #64748b;\n    font-size: 12px;\n    line-height: 1.5;\n  }\n\n  .operator-utilization-card__eyebrow {\n    color: #2f539d;\n  }\n}\n\n.operator-utilization-card__badge {\n  flex-shrink: 0;\n  padding: 7px 10px;\n  border: 1px solid rgba(14, 165, 233, 0.16);\n  border-radius: 999px;\n  background: rgba(14, 165, 233, 0.08);\n  color: #0369a1;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.operator-utilization-card__badge--violet {\n  border-color: rgba(124, 58, 237, 0.16);\n  background: rgba(124, 58, 237, 0.08);\n  color: #6d28d9;\n}\n\n.operator-utilization-card__badge--danger {\n  border-color: rgba(239, 68, 68, 0.15);\n  background: rgba(239, 68, 68, 0.08);\n  color: #dc2626;\n}\n\n.operator-view-switch {\n  display: inline-flex;\n  flex-shrink: 0;\n  gap: 3px;\n  padding: 3px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #f8fafc;\n\n  button {\n    border: 0;\n    border-radius: 7px;\n    padding: 6px 10px;\n    background: transparent;\n    color: #64748b;\n    cursor: pointer;\n    font-size: 11px;\n    font-weight: 700;\n    transition: all 180ms ease;\n\n    &.active {\n      background: #fff;\n      color: #1d4ed8;\n      box-shadow: 0 3px 10px rgba(15, 23, 42, 0.08);\n    }\n  }\n}\n\n.operator-utilization-loading,\n.operator-utilization-empty {\n  min-height: 240px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  padding: 30px;\n  border: 1px dashed #cbd5e1;\n  border-radius: 22px;\n  background: #fff;\n  text-align: center;\n}\n\n.operator-utilization-loading__spinner {\n  width: 30px;\n  height: 30px;\n  border: 3px solid #dbeafe;\n  border-top-color: #2563eb;\n  border-radius: 50%;\n  animation: operator-spin 0.85s linear infinite;\n}\n\n.operator-utilization-loading {\n  text-align: left;\n\n  strong {\n    display: block;\n    color: #0f172a;\n  }\n\n  p {\n    margin: 4px 0 0;\n    color: #64748b;\n    font-size: 12px;\n  }\n}\n\n.operator-utilization-empty {\n  flex-direction: column;\n\n  > span {\n    color: #94a3b8;\n    font-size: 38px;\n  }\n\n  h3 {\n    margin: 0;\n    color: #0f172a;\n  }\n\n  p {\n    margin: 0;\n    color: #64748b;\n  }\n}\n\n@keyframes operator-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 1500px) {\n  .operator-utilization-kpi-grid {\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 1050px) {\n  .operator-utilization-chart-grid--overview,\n  .operator-utilization-chart-grid--balanced {\n    grid-template-columns: 1fr;\n  }\n\n  .operator-utilization-hero {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .operator-utilization-hero__meta {\n    min-width: 240px;\n  }\n}\n\n@media (max-width: 760px) {\n  .operator-utilization-dashboard {\n    margin-top: 18px;\n  }\n\n  .operator-utilization-hero {\n    min-height: auto;\n    padding: 22px 18px;\n    border-radius: 18px;\n  }\n\n  .operator-utilization-hero__meta {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .operator-utilization-kpi-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .operator-utilization-card {\n    padding: 18px 14px 12px;\n    border-radius: 17px;\n  }\n\n  .operator-utilization-card__header {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
